<template>
    <div class="ah-page payment-pdf-page" v-if="form && form.sno">
        <div class="print-controls">
            <el-button type="info" @click="handleBackBtnClick">返回</el-button>
            <el-button type="primary" @click="handlePrintBtnClick">列印</el-button>
        </div>
        <div class="payment-pdf-preview">
            <div class="branding">
                <img class="logo" :src="$store.getters['menu/companyInfo'].logo" alt="" />
            </div>
            <!-- 請款類型 -->
            <h1 v-if="paymentTypeName" class="paymentType">{{ paymentTypeName }}</h1>
            <table cellpadding="0" cellspacing="0" style="width: 100%; margin-bottom: 20px">
                <tr>
                    <td style="max-width: 600px;">
                        <!-- 摘要 -->
                        <h2 class="paymentName">{{ form.nam }}</h2>
                        <!-- 專案 -->
                        <div v-if="form.typ == 2" class="paymentProject">專案：{{ form.projectName }}</div>
                        <div v-if="form.typ == 3" class="paymentProject">特定費用項目：{{ form.projectName }}</div>
                        <div>
                            支出項目：
                            <span v-if="form.iteM_SNO && (form.sigN_STS == 2 || form.sigN_STS == 3)">{{ this.hierarchyItemNames(form.iteM_SNO) }}</span>
                            <span v-else>---</span>
                        </div>
                    </td>
                    <td>
                        <table class="spec-table compact" cellpadding="0" cellspacing="0" style="margin: 20px 0px 0px auto">
                            <tbody>
                                <tr>
                                    <th>請款單號：</th>
                                    <td>{{ form.payoo }}</td>
                                </tr>
                                <tr>
                                    <th>申請人：</th>
                                    <td>{{ form.creator }}</td>
                                </tr>
                                <tr>
                                    <th>申請日期：</th>
                                    <td>{{ form.crT_DAT | dateFormater("YYYY-MM-dd") }}</td>
                                </tr>
                                <tr>
                                    <th>製表日期</th>
                                    <td>{{ new Date().getTime() | dateFormater("YYYY-MM-dd") }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </table>

            <hr class="hidden" />
            <div class="section" style="margin: 0 0 20px 0">
                <table class="spec-table" cellpadding="0" cellspacing="0">
                    <tbody>
                        <tr>
                            <th>付款對象：</th>
                            <td>{{ getPayToName }}</td>
                        </tr>
                        <tr>
                            <th>預計付款日期：</th>
                            <td>{{ form.pdat | dateFormater("YYYY-MM-dd") }}</td>
                        </tr>
                        <tr>
                            <th><span v-if="form.useR_PAY_WAY != form.paY_WAY">預計</span>付款方式：</th>
                            <td>{{ form.useR_PAY_WAY === 1 ? "零用現金" : "銀行轉帳" }}</td>
                        </tr>
                        <tr v-if="form.useR_PAY_WAY != form.paY_WAY && form.paY_WAY">
                            <th>實際付款方式：</th>
                            <td>{{ form.useR_PAY_WAY === 1 ? "零用現金" : "銀行轉帳" }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div style="border-top: 1px solid #000; padding: 15px 0px" v-if="form.paY_TO == 3">
                <table class="spec-table" cellpadding="0" cellspacing="0">
                    <tbody>
                        <tr>
                            <th>勞務所得類別：</th>
                            <td>{{ getServiceTypeTxt(form.serviceType) }}</td>
                        </tr>
                        <tr>
                            <th>工作內容：</th>
                            <td>
                                <div v-if="form.oS_MEM && form.oS_MEM != ''" style="white-space: pre">{{ form.oS_MEM }}</div>
                                <div v-else>(無)</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 15px 0px">
                <el-row :gutter="20">
                    <el-col :span="15">
                        <div class="section" v-if="form.useR_PAY_WAY === 2">
                            <table class="spec-table" cellpadding="0" cellspacing="0">
                                <tbody>
                                    <tr>
                                        <th>收款銀行：</th>
                                        <td>
                                            <span v-if="form.abroadBankName">{{ form.abroadBankName }}</span>
                                            <div v-else-if="form.bankName">
                                                {{ form.bankName }} <br />{{ form.vdR_BNK_BOO }} -
                                                {{ form.vdR_BNK_DOO }}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>收款戶名：</th>
                                        <td>{{ form.vdR_BNK_TPC }}</td>
                                    </tr>
                                    <tr>
                                        <th>收款帳號：</th>
                                        <td>{{ form.vdR_BNK_ACC }}</td>
                                    </tr>
                                    <tr v-if="form.vdR_BNK_NOTE && form.vdR_BNK_NOTE != ''">
                                        <th>備註、其他資訊</th>
                                        <td>
                                            {{ form.vdR_BNK_NOTE }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-else>
                            <span style="opacity: 0">.</span>
                        </div>
                    </el-col>
                    <el-col :span="9">
                        <div class="section">
                            <table class="spec-table" cellpadding="0" cellspacing="0" style="width: 100%">
                                <tbody>
                                    <tr>
                                        <th>請款金額：</th>
                                        <td class="right">
                                            <Money :v="form.amt" :precision="form.cny === 'TWD' ? null : 4" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>勞務稅：</th>
                                        <td class="right">
                                            <Money :v="form.taX_AMT ? -form.taX_AMT : 0" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>二代健保：</th>
                                        <td class="right">
                                            <Money :v="form.geN2_AMT ? -form.geN2_AMT : 0" />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div style="margin-bottom: 40px; padding: 15px 0; border-bottom: 1px solid #000">
                <table class="spec-table" cellpadding="0" cellspacing="0" style="width: 100%">
                    <tbody>
                        <tr>
                            <th>實付金額：</th>
                            <td class="right" style="font-size: 12pt">
                                <Money :v="form.amt - form.taX_AMT - form.geN2_AMT" :precision="form.cny === 'TWD' ? null : 4" />
                                <span style="font-size: 8pt"> {{ form.cny }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div>
                <el-row :gutter="20">
                    <el-col :span="15" v-if="getAuditData">
                        <div class="section">
                            <h2>付款明細</h2>
                            <table class="spec-table" cellpadding="0" cellspacing="0" v-if="form.sigN_STS == 2 || form.sigN_STS == 3">
                                <tbody>
                                    <tr>
                                        <th>填寫人：</th>
                                        <td>{{ getAuditData.stF_NAM }}</td>
                                    </tr>
                                    <tr>
                                        <th>填寫日期：</th>
                                        <td>
                                            {{ getAuditData.sdat | dateFormater("YYYY-MM-dd") }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>付款日期：</th>
                                        <td>{{ form.paY_DAT | dateFormater("YYYY-MM-dd") }}</td>
                                    </tr>
                                    <tr v-if="form.paY_WAY == 2">
                                        <th>付款帳戶：</th>
                                        <td>{{ payBankName }}</td>
                                    </tr>
                                    <tr>
                                        <th>支出項目：</th>
                                        <td>{{ form.iteM_NAM }}</td>
                                    </tr>
                                    <tr v-show="form.taX_CHK">
                                        <th>代扣稅付款日：</th>
                                        <td>{{ form.taX_PAY_DAT | dateFormater("YYYY-MM-dd") }}</td>
                                    </tr>
                                    <tr v-show="form.geN2_CHK">
                                        <th>代扣二代健保付款日：</th>
                                        <td>
                                            {{ form.geN2_PAY_DAT | dateFormater("YYYY-MM-dd") }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div v-else>尚未填寫</div>
                        </div>
                    </el-col>
                    <el-col :span="9" v-if="getAuditData">
                        <div class="section">
                            <h2>確認付款</h2>
                            <table class="spec-table" cellpadding="0" cellspacing="0" v-if="form.sigN_STS == 3">
                                <tbody>
                                    <tr>
                                        <th>確認人：</th>
                                        <td>{{ getPassAuditData.stF_NAM }}</td>
                                    </tr>
                                    <tr>
                                        <th>確認日期：</th>
                                        <td>
                                            {{ getPassAuditData.sdat | dateFormater("YYYY-MM-dd") }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div v-if="form.sigN_STS != 3">尚未確認</div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="sign-area">
                <div class="sign-block">
                    <div class="label">領款簽收</div>
                </div>
            </div>
            <div class="pdf-footer" style="line-height: 165%; margin-top: 20px">
                <div class="company-name" v-if="companyName" style="font-weight: bold">
                    {{ companyName }}
                </div>
                <div class="company-addr" v-if="companyAddr">{{ companyAddr }}</div>
                <div class="company-email" v-if="companyEmail">{{ companyEmail }}</div>
                <div>
                    <span class="company-tel" v-if="companyTel" style="padding-right: 15px">TEL： {{ companyTel }}</span>
                    <span class="company-fax" v-if="companyFax">FAX： {{ companyFax }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { paymentType, serviceTypeList } from '@/assets/commonData/options';
import _ from 'lodash';

export default {
    name: 'PaymentPDFPage',
    components: {},
    data() {
        return {
            form: {},
            payToList: null,
            projectList: null,
            invoiceType: null,
        };
    },
    computed: {
        isAudited() {
            if (this.form.audits) {
                return this.form.audits.some((x) => x.fin === 1);
            }
            return false;
        },
        getNowAuditing() {
            if (this.form.audits) {
                for (let i = 0; i < this.form.audits.length; i += 1) {
                    if (this.form.audits[i].fin === 0) {
                        return i;
                    }
                }
            }
            return 0;
        },
        getPayToName() {
            if (this.payToList && this.form.vdR_SNO) {
                return this.payToList.find((x) => x.sno === this.form.vdR_SNO).fnam;
            }
            return this.form.PAY_NAM || `公司員工 - ${this.form.payName}`;
        },
        getPayToAccountName() {
            if (this.payToList && this.form.vdR_SNO) {
                return this.payToList.find((x) => x.sno === this.form.vdR_SNO).bnK_TPC;
            }
            return '';
        },
        getPayToAccount() {
            if (this.payToList && this.form.vdR_SNO) {
                return this.payToList.find((x) => x.sno === this.form.vdR_SNO).bnK_ACC;
            }
            return '';
        },

        checkPassed() {
            if (this.form.audits && this.form.audits.find((x) => x.menU_UNT === 'A03' && x.fin === 1)) {
                return true;
            }
            return false;
        },
        checkAudited() {
            if (this.form.audits && this.form.audits.find((x) => x.menU_UNT === 'A02' && x.fin === 1)) {
                return true;
            }
            return false;
        },
        getInvoiceName() {
            if (this.invoiceType && this.form.filE_TYP) {
                return this.invoiceType.find((x) => x.key === this.form.filE_TYP).value;
            }
            return '';
        },
        getAuditData() {
            if (this.form.audits) {
                return this.form.audits.find((x) => x.menU_UNT === 'A02');
            }
            return null;
        },
        getPassAuditData() {
            if (this.form.audits) {
                return this.form.audits.find((x) => x.menU_UNT === 'A03');
            }
            return null;
        },
        payBankName() {
            const bank = this.$store.getters['bankAccount/bankAccountOptions'].find(
                // eslint-disable-next-line eqeqeq
                (x) => x.sno == this.form.paY_BNK_SNO,
            );
            if (bank) {
                return bank.bnK_NAM;
            }
            return null;
        },
        companyName() {
            return this.$store.getters['menu/companyInfo'].cH_CMP;
        },
        companyAddr() {
            return this.$store.getters['menu/companyInfo'].cH_ADR;
        },
        companyEmail() {
            return this.$store.getters['menu/companyInfo'].email;
        },
        companyTel() {
            return this.$store.getters['menu/companyInfo'].tel;
        },
        companyFax() {
            return this.$store.getters['menu/companyInfo'].fax;
        },

        paymentTypeName() {
            return _.find(paymentType, ['key', this.form.typ])?.formName;
        },
    },
    created() {
        this.fetchDetailData();
    },
    methods: {
        fetchDetailData() {
            if (this.$route.params.sno) {
                this.$api({
                    url: `/PaymentManagenmentPage/GetPaymentInfo?Sno=${this.$route.params.sno}`,
                    method: 'GET',
                }).then((resp) => {
                    this.form = resp.data.item;
                    this.fetchOtherLists();
                    console.log('Payment PDF: ', this.form);
                });
            }
        },
        fetchOtherLists() {
            this.$api({
                url: '/PaymentManagenmentPage/GetAttachTypeOption',
                method: 'GET',
            }).then((resp) => {
                this.invoiceType = resp.data.items;
            });
            if (this.form.paY_TO === 2) {
                // 現有廠商清單
                this.$api({
                    url: '/Outsourcing/GetOutsourcingList?VDR_TYP=VD&PageSize=999&PageNum=1',
                    method: 'GET',
                }).then((resp) => {
                    this.payToList = resp.data.items;
                });
            } else if (this.form.paY_TO === 3) {
                // 現有外包清單
                this.$api({
                    url: '/Outsourcing/GetOutsourcingList?VDR_TYP=OS&PageSize=999&PageNum=1',
                    method: 'GET',
                }).then((resp) => {
                    this.payToList = resp.data.items;
                });
            }
            if (this.form.typ === 2) {
                // 專案
                this.$api({
                    url: '/PaymentManagenmentPage/GetProjectList?TYP=PJ',
                    method: 'GET',
                }).then((resp) => {
                    this.projectList = resp.data.items;
                });
            } else if (this.form.typ === 3) {
                // 特定費用項目
                this.$api({
                    url: '/PaymentManagenmentPage/GetProjectList?TYP=SP',
                    method: 'GET',
                }).then((resp) => {
                    this.projectList = resp.data.items;
                });
            }
        },
        hierarchyItemNames(itemSno) {
            const hierarchy = [null, null, null];
            const statementOptionsForUi = this.$store.getters['statement/statementUiOptions'];

            const types = [
                { key: 'payoutSettings', name: '營業支出' },
                { key: 'invoiceSettings', name: '營業收入' },
                { key: 'cInSettings', name: '營業其他收入' },
                { key: 'cInElseSettings', name: '財務資產收入' },
                { key: 'cOutSettings', name: '營業其他支出' },
                { key: 'cOutElseSettings', name: '財務資產支出' },
            ];

            for (const t in types) {
                const options = statementOptionsForUi[types[t].key];
                for (const i in options) {
                    const lv1Item = options[i];
                    for (const j in lv1Item.childSettings) {
                        const lv2Item = lv1Item.childSettings[j];
                        if (lv2Item.sno === itemSno) {
                            hierarchy[0] = types[t].name;
                            hierarchy[1] = lv1Item.iteM_NAM;
                            hierarchy[2] = lv2Item.iteM_NAM;
                            break;
                        }
                    }
                }
            }

            return hierarchy.join(' / ');
        },
        getServiceTypeTxt(serviceTypeNum) {
            const s = serviceTypeList.find((x) => x.value === serviceTypeNum);
            if (s) return s.label;
            return '';
        },
        handlePrintBtnClick() {
            window.print();
        },
        handleBackBtnClick() {
            this.$router.push({ name: 'payment-detail', params: { sno: this.$route.params.sno } });
        },
    },
};
</script>
<style lang="scss">
@page {
    size: Auto;
    orphans: 4;
    margin: 1cm 0cm 0cm 0cm;
    widows: 2;
}

.payment-pdf-page {
    .print-controls {
        margin: 140px 30px 0 30px;
        text-align: right;

        @media print {
            display: none;
        }
    }

    .payment-pdf-preview {
        position: relative;
        line-height: initial;
        background-color: #fff;
        font-size: 7pt;
        margin: 30px 30px 30px 30px;
        padding: 75px;
        box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        border: 1px solid #eee;
        width: 900px;
        margin: 0 auto;

        @media print {
            position: relative;
            width: unset;
            background-color: #fff;
            margin: 0;
            padding: 1cm 1cm 0cm 1cm;
            border: 0;
            border-radius: 0;
            box-shadow: none;
        }

        .page-title {
            @media print {
                display: none;
            }
        }

        .branding {
            position: absolute;
            top: 0.5cm;
            right: 1.6cm;

            .logo {
                position: relative;
                max-width: 3cm;
                max-height: 1.6cm;
            }
        }

        .paymentType {
            padding: 0.5cm 0 0 0;
            margin: 0 0 10px 0;
            font-size: 17pt;
        }

        .paymentName {
            word-break: break-all;
            font-size: 12pt;
            margin: 0 0 5px 0;
            padding-right: 10px;
        }

        .no-break {
            page-break-inside: avoid;
        }

        .section {
            margin: 0cm 0 0cm 0;

            h2 {
                text-transform: uppercase;
                // border-bottom: 1px solid #000;
                font-size: 7pt;
                padding: 0 0 0.1cm 0;
                margin: 0 0 0.2cm 0;
            }

            &.framed {
                border: 1px solid #000;
                padding: 0.25cm;
            }
        }

        .spec-table {
            line-height: 150%;

            th {
                text-align: left;
                width: 2.5cm;
                font-weight: normal;
                vertical-align: top;
            }

            td {
                width: auto;

                &.right {
                    text-align: right;
                }
            }

            &.compact {
                th {
                    width: 2.3cm;
                }
            }
        }

        .submit-info {
            position: absolute;
            top: 0;
            right: 0.5cm;
        }

        hr.hidden {
            border-bottom: 0px solid #000;
            height: 0px;
            margin: 0cm 0;
        }

        .sign-block {
            margin: 1cm 0 0 auto;
            width: 6cm;
            font-weight: bold;
            border-bottom: 1px solid #000;
            padding-bottom: 0.3cm;
        }
    }
}
</style>
